/**
 * 页面常量
 **/
const html = {

  boptt: "Boptt Platform",
  talkie: "Intercom Management ",
  control: "Dispatch Platform",
  platform: "BopttPlatform",
  latestIntercomServiceVersion: "latest Intercom Service Version:",
  downLoadUrl: "downLoad url",
  currentIntercomServiceVersion: "currentIntercomServiceVersion：",
  currentIntercomServiceVersion2: "The dispatcher's voice intercom needs to use the agent customer service terminal,",
  pleaseUpdate: "please update"
};

export default html;



// WEBPACK FOOTER //
// ./src/api/lang/modules/constant/html_en.js